export const REDUCER_KEY = 'notification';
